import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PARTNERS_PAGE } from "@/constants/partners-page";

export const PartnersFaq = () => {
  const { faqs } = PARTNERS_PAGE;

  return (
    <Container maxWidth="md" sx={{ mt: { xs: 6, md: 10 } }}>
      <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 3, textAlign: "center" }}>
        {faqs.title}
      </Typography>

      <Stack>
        {faqs.items.map((item) => (
          <Accordion key={item.question} disableGutters elevation={1}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1" component="h3">
                {item.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ color: "text.secondary", lineHeight: 1.7 }}>{item.answer}</Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Container>
  );
};
